import { render, staticRenderFns } from "./gallery-card-warren.vue?vue&type=template&id=223c218e&scoped=true&"
import script from "./gallery-card-warren.vue?vue&type=script&lang=js&"
export * from "./gallery-card-warren.vue?vue&type=script&lang=js&"
import style0 from "./gallery-card-warren.vue?vue&type=style&index=0&id=223c218e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c218e",
  null
  
)

export default component.exports